import React from "react";
import Img from "../../../assets/images/image";
import TwoColumn from "../../../Components/TwoColumn";
import WhatMakesUsDifferent from "../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../Components/GetInTouch";
import { data } from "../../../Data/data";
import { Col, Container, Row } from "react-bootstrap";
import GAlign from "../../../Components/GAlign";
import Typography from "../../../Components/Typography/Typography";
import { Helmet } from "react-helmet";
import HeroSection from "../../../Components/HeroSection/HeroSection";

export default function DigitalMarketing() {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Digital Marketing</title>
            <meta name="description" content="Build an omnichannel presence for 10X growth & ROI with Witmates. We run innovative campaigns & implement effective strategies for exponential growth." />
            <link rel="canonical" href="https://www.witmates.com/digital_marketing" />
         </Helmet>
         <div>
            <HeroSection
               image={Img.digitalMarketingBanner}
               heading={
                  <>
                     Accelerate Your <br /> Growth <span className="witmates-theme-color">10X</span> with{" "}
                     <span className="witmates-theme-color">
                        Digital <br /> Marketing
                     </span>{" "}
                     Strategies
                  </>
               }
               description={
                  <>
                     Our in-house team of growth hackers will help you build an omnichannel digital presence. With our effective digital marketing strategies and innovative campaigns, we’ll ensure you
                     drive up to 10X growth and ROI for your business.
                  </>
               }
               link
            />
            <Container>
               <Row>
                  <Col className="mobMt20 mobMb20 pt30 pb30 mt30 mb30 ">
                     <GAlign align="center" mobalign="center">
                        <Typography element="span" fontWeight={600} className="fs60 tabHeadingFontSize mobHeadingFontSize" syne>
                           <Typography element="span" className="colorOrange" syne>
                              {" "}
                              Services{" "}
                           </Typography>
                           We Provide
                        </Typography>
                     </GAlign>
                  </Col>
               </Row>
            </Container>
            <div id="contentMarketing" className="d-flex justify-content-center align-items-center mobPt0 pt40">
               <TwoColumn
                  image={Img.contentMarketing}
                  heading={
                     <>
                        Content <br /> Marketing
                     </>
                  }
                  pageName="CONTENT"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        In a world full of digital noise, how can you make your voice heard? That's where our content marketing services play a vital role.
                        <br />
                        Our expert team specializes in crafting compelling, informative, and engaging content that captivates the attention of your audience and drives exceptional results for your
                        business.
                        <br />
                        Whether it's blog posts, articles, videos, infographics, or just anything, we know how to tell your brand's story in a way that resonates with your audience.
                        <br />
                        Our team of expert writers and content strategists will work closely with you to understand your goals and create a content strategy that aligns with your brand identity and
                        drive exceptional growth for your business.
                     </>
                  }
               />
            </div>
            <div id="socialMediaMarketing" className="d-flex justify-content-center align-items-center mobPt60 pt100">
               <TwoColumn
                  reverse
                  image={Img.socialMediaMarketing}
                  heading={
                     <>
                        Social Media <br /> Marketing
                     </>
                  }
                  pageName="SOCIAL MEDIA"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        Likes, comments, shares - the power of social media is undeniable.
                        <br /> With our social media marketing services, We help our clients harness that power to connect with their audience and grow their brand. Our team excels in knowing all the
                        ins and outs of major social media platforms and leveraging that knowledge to help you with your social media presence.
                        <br /> We'll develop a customized social media strategy that is tailor-made for your business. It will not only increase your brand's visibility but also engages your followers
                        and builds a loyal community.
                        <br /> From creating captivating posts and running targeted ad campaigns to monitoring analytics and measuring performance, we've got you covered.
                        <br /> Make us your social media partner, and together let's make your brand achieve unbelievable growth on social media.
                     </>
                  }
               />
            </div>
            <div id="SeoContent" className="d-flex justify-content-center align-items-center mobPt40 pt100">
               <TwoColumn
                  image={Img.SEO}
                  heading={<>Search Engine Optimization</>}
                  pageName="SEO"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        Want your website to rank higher on search engines? We are here to make that happen. We have a team of SEO wizards who are able to optimize your website to its fullest
                        potential.
                        <br />
                        From conducting keyword research and optimizing on-page elements to building high-quality backlinks, we implement the best SEO practices that get results.
                        <br />
                        With our help, you'll climb the search engine rankings, increase organic traffic, and attract more potential customers to your website.
                        <br />
                        Don't let your competitors steal the spotlight - let us be your SEO superheroes and watch your online presence soar.
                     </>
                  }
               />
            </div>
            <div id="ppcAdvertising" className="d-flex justify-content-center align-items-center mobPt60 pt100">
               <TwoColumn
                  reverse
                  image={Img.payPerClick}
                  heading={
                     <>
                        Pay-per-click <br /> (PPC) Advertising
                     </>
                  }
                  pageName="PPC"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        Don't have the patience to wait for months or do you just want to make your brand present in front of the right people at the right time?
                        <br />
                        We provide PPC advertising services that are the key to unlocking targeted visibility and driving quality traffic to your website in a very few time.
                        <br /> We create and manage strategic pay-per-click campaigns on platforms like Google Ads and Bing Ads, and ensure that your ads reach your ideal audience that converts.
                        <br /> Our team of PPC experts will conduct thorough keyword research, craft compelling ad copy, and optimize your campaigns for maximum ROI. With our data-driven approach and
                        continuous monitoring, we'll fine-tune your campaigns to deliver exceptional and measurable results.
                        <br /> Discover the power of Pay-per-click advertising and grow your business with our efficient and cost-effective PPC services.
                     </>
                  }
               />
            </div>
            <div id="emailMarketing" className="d-flex justify-content-center align-items-center mobPt40 pt100">
               <TwoColumn
                  image={Img.emailMarketing}
                  heading={
                     <>
                        Email <br /> Marketing
                     </>
                  }
                  pageName="EMAIL MARKETING"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        Looking for a direct and effective way to reach your customers? Email Marketing is undoubtedly the best way to do this.
                        <br /> We provide email marketing services that will help you build and retain strong relationships with your audience. We'll develop tailored email campaigns that engage,
                        inform, and convert your subscribers into loyal customers.
                        <br /> From designing eye-catching templates and creating personalized content to managing your subscriber list and tracking performance, we'll take care of everything in
                        between. Seeing our expertise in email marketing best practices, feel free to expect higher open rates, click-through rates, and overall engagement.
                        <br /> Partner with us, and together we'll take your customer communication to new heights.
                     </>
                  }
               />
            </div>
            <div id="marketStrategy" className="d-flex justify-content-center align-items-center mobPt60 mobPb40 pt100 pb100">
               <TwoColumn
                  reverse
                  image={Img.marketResearchAndStrategy}
                  heading={
                     <>
                        Market Research <br /> and Strategy
                     </>
                  }
                  pageName="STRATEGY"
                  buttonName="Learn More"
                  redirection="/get-in-touch"
                  isZoom={true}
                  description={
                     <>
                        In today's competitive digital landscape, an unbeatable strategy and extensive research play the most important role in driving growth for any business.
                        <br /> At Witmates, we conduct in-depth research to understand your target market, analyze your competition, and identify valuable insights that enable us to plan and
                        strategise our digital marketing efforts.
                        <br /> Armed with this knowledge, we develop a comprehensive strategy that aligns with your business goals and sets you apart from the competition ultimately giving you the
                        desired growth.
                        <br /> Get ready to make data-driven decisions and achieve digital marketing success for your business with our marketing expertise.
                     </>
                  }
               />
            </div>
            <WhatMakesUsDifferent data={data.digitalMarketingData} height="415px" />
            <GetInTouch />
         </div>
      </div>
   );
}
